var mapConsent = require('./map-consent');

(function ($) {
	var bounds, map, marker, infoWindow, infoWindowContainers;

	var isMobile = window.innerWidth < 640;

	let polygonClickFlag = false;

	var createContactSalesMap = function () {
		if (document.getElementById('contact-gmap-sales')) {
			createContactSalesMapInit();
		}
	};

	var createContactSalesMapInit = async function () {
		const markerScale = 0.7; // 30% smaller
		const markerIconUrl = theme_directory + '/assets/pin-new.png';
		// pin-new.png is 60x88px; scale to 70% (42x62)
		const markerIconWidth = Math.round(60 * markerScale);
		const markerIconHeight = Math.round(88 * markerScale);
		const markerIcon = {
			url: markerIconUrl,
			scaledSize: new google.maps.Size(markerIconWidth, markerIconHeight),
			anchor: new google.maps.Point(Math.round(markerIconWidth / 2), markerIconHeight),
		};

		// Declare to hold Team from REST endpoint
		let salesPeopleRaw;

		// Make the fetch call to the current environment
		const whereAmI = window.location.protocol + '//' + window.location.hostname;

		// Get the Team
		const res = await fetch(whereAmI + '/wp-json/wp/v2/team/?per_page=100');

		// JSON that Team
		const team = await res.json();

		// Only give us Team members who have Locations and Territories
		salesPeopleRaw = await team.filter((person) => {
			return person.acf.territories.length > 0;
		});

		// Create object to hold processed Team for use in in creating pins, infowindows, and polygons
		const salesPeople = {};
		for (let person of salesPeopleRaw) {
			salesPeople[person.slug] = {
				location:
					person.acf.location?.lat && person.acf.location?.lng
						? { lat: person.acf.location.lat, lng: person.acf.location.lng }
						: null,
				territories: person.acf.territories,
				niceName: person.title.rendered,
				phone: person.acf.phone,
				email: person.acf.email,
				markerCardOverride: person.acf.marker_card_override,
				slug: person.slug,
			};
		}

		var zoomLevel = window.innerWidth < 1000 ? 4 : 5;

		map = new google.maps.Map(document.getElementById('contact-gmap-sales'), {
			center: { lat: 39.5, lng: -98.35 },
			mapTypeControl: false,
			styles: [
				{
					featureType: 'administrative',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#444444' }],
				},
				{
					featureType: 'administrative.province',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#ff0000' }, { visibility: 'on' }, { weight: '2' }],
				},
				{
					featureType: 'administrative.country',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#ff0000' }, { visibility: 'on' }, { weight: '2' }],
				},
				{ featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f2f2f2' }] },
				{
					featureType: 'landscape.natural.terrain',
					elementType: 'all',
					stylers: [{ visibility: 'simplified' }],
				},
				{
					featureType: 'landscape.natural.terrain',
					elementType: 'geometry',
					stylers: [{ visibility: 'off' }],
				},
				{ featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
				{
					featureType: 'road',
					elementType: 'all',
					stylers: [{ saturation: -100 }, { lightness: 45 }],
				},
				{
					featureType: 'road.highway',
					elementType: 'all',
					stylers: [{ visibility: 'simplified' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.icon',
					stylers: [{ visibility: 'simplified' }],
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.icon',
					stylers: [{ visibility: 'off' }],
				},
				{ featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
				{
					featureType: 'water',
					elementType: 'all',
					stylers: [{ color: '#9bd3ea' }, { visibility: 'on' }],
				},
			],
			zoom: zoomLevel,
			streetViewControl: false,
		});

		bounds = new google.maps.LatLngBounds();
		var allMarkers = [];
		var allInfoWindows = [];

		function addEventListenersToMarkers(marker, infoWindow) {
			google.maps.event.addListener(
				marker,
				'click',
				(function (marker) {
					return function () {
						allInfoWindows.forEach((window) => {
							window.close();
						});
						infoWindow.open(map, marker);
					};
				})(marker),
			);
			// google.maps.event.addListener(
			// 	marker,
			// 	'closeclick',
			// 	(function (marker) {
			// 		return function () {
			// 			map.fitBounds(bounds);
			// 		};
			// 	})(marker)
			// );
		}

		// Iterate through each person
		const people = Object.keys(salesPeople);
		people.forEach((person) => {
			if (salesPeople[person].location) {
				var position = new google.maps.LatLng(
					salesPeople[person].location.lat,
					salesPeople[person].location.lng,
				);

				// bounds.extend(position);

				marker = new google.maps.Marker({
					icon: markerIcon,
					position: position,
					map: map,
					id: salesPeople[person].slug,
				});

				allMarkers.push(marker);
			}

			infoWindow = new google.maps.InfoWindow({
				anchor: marker,
				content: `
				<div class="infowindow-container">
					<p class="infowindow-container__title">${
						salesPeople[person].markerCardOverride
							? salesPeople[person].markerCardOverride
							: salesPeople[person].niceName
					}</p>
					<p class="infowindow-container__info">
					<span>P: ${salesPeople[person].phone}</span><br />
					<span><a href="mailto:${salesPeople[person].email}">${salesPeople[person].email}</a></span>
					</p>
				</div>
				`,
				id: person,
				minWidth: 350,
				pixelOffset: new google.maps.Size(220, 120),
			});
			infoWindow.close();

			var infoWindowContent = `
				<div id="${person}" class="infowindow-container hide">
					<p class="infowindow-container__title">${salesPeople[person].niceName}</p>
					<p class="infowindow-container__info">
					<span>P: ${salesPeople[person].phone}</span><br />
					<span><a href="mailto:${salesPeople[person].email}">${salesPeople[person].email}</a></span>
					</p>
				</div>
				`;
			$('#infowindow').append(infoWindowContent);

			allInfoWindows.push(infoWindow);

			// if (isMobile) {
			// 	map.fitBounds(bounds);
			// }
		});

		// Capture infoWindows for polygon click show/hide later
		infoWindowContainers = document.querySelectorAll('.infowindow-container');

		// For scope to keep infowindows associated with the corresponding markers
		for (let i = 0; i < allMarkers.length; i++) {
			addEventListenersToMarkers(allMarkers[i], allInfoWindows[i]);
		}

		// window.addEventListener('resize', function () {
		// 	if (isMobile) {
		// 		map.fitBounds(bounds);
		// 		// allInfoWindows.forEach((window) => {
		// 		// 	window.setOptions({ minWidth: 250 });
		// 		// });
		// 	} else {
		// 		// allInfoWindows.forEach((window) => {
		// 		// 	window.setOptions({ minWidth: 350 });
		// 		// });
		// 	}
		// });

		setContactSalesMapPolygons(salesPeople, allMarkers, infoWindowContainers, map);
	};

	var setContactSalesMapPolygons = async function (salesPeople, markers, infoWindows, map) {
		// Get each salesperson
		const people = Object.keys(salesPeople);
		// Get the coordinates of each territory asyncronously
		const coords = await fetch(theme_directory + '/src/js/maps/coords.json').then((res) =>
			res.json(),
		);
		const allPolygons = [];
		// Iterate through each person
		people.forEach((person) => {
			// Collect their name for use in loops
			const name = person;

			// Declare an array to collect the person's polygons
			const ownedPolygons = [];

			// Iterate through the person's territories
			salesPeople[name].territories.forEach((territory) => {
				// Match the territory to the territory in the coords object
				coords[territory].forEach((array, i) => {
					// Construct the polygon.
					const polygon = new google.maps.Polygon({
						paths: array,
						strokeColor: '#FFFFFF',
						strokeOpacity: 0,
						strokeWeight: 2,
						fillColor: '#000000',
						fillOpacity: 0,
						owner: name,
						id: name + i,
						selected: false,
					});

					// Push the polygons into the person's polygon bucket
					ownedPolygons.push(polygon);
					// Push the polygons into the allPolygons array for use in listeners below
					allPolygons.push(polygon);
				});
			});

			// Iterate over the person's polygon bucket
			ownedPolygons.forEach((polygon) => {
				// Add listeners
				polygon.addListener('mouseover', function () {
					// When mouseover each polygon in the bucket, highlight every other polygon in the bucket if it is not selected
					for (let i = 0; i < ownedPolygons.length; i++) {
						if (this.selected === false) {
							ownedPolygons[i].setOptions({
								strokeOpacity: 1,
								fillOpacity: 0.5,
								fillColor: '#000000',
							});
						}
					}
				});
				polygon.addListener('mouseout', function () {
					// Hide highlight on mouseout if not selected
					for (let i = 0; i < ownedPolygons.length; i++) {
						if (this.selected === false) {
							ownedPolygons[i].setOptions({ strokeOpacity: 0, fillOpacity: 0 });
						}
					}
				});
				polygon.addListener('click', function (event) {
					// Save "this" reference scope for use in infoWindowContainers.forEach below
					const thisPolygon = this;

					// Set all polygons to transparent
					for (let i = 0; i < allPolygons.length; i++) {
						allPolygons[i].setOptions({ strokeOpacity: 0, fillOpacity: 0 });
					}
					// When click each polygon in the bucket, highlight every other polygon in the bucket
					for (let i = 0; i < ownedPolygons.length; i++) {
						ownedPolygons[i].setOptions({
							strokeOpacity: 1,
							fillOpacity: 1,
							fillColor: '#FF0000',
						});
					}
					// Set all polygon selected flags to false
					for (let i = 0; i < allPolygons.length; i++) {
						allPolygons[i].setOptions({ selected: false });
					}
					// Set these polygons' selected flag to true
					for (let i = 0; i < ownedPolygons.length; i++) {
						ownedPolygons[i].setOptions({ selected: true });
					}
					// // Close all windows
					// infoWindows.forEach((window) => {
					// 	window.close();
					// });
					// // Get the marker whose id corresponds to the polygon owner
					// const marker = markers.find((marker) => {
					// 	return marker.id === polygon.owner;
					// });
					// // Get the marker whose id corresponds to the polygon owner
					// const window = infoWindows.find((window) => {
					// 	return window.id === polygon.owner;
					// });
					// // Open that thing
					// window.open(map, marker);

					document.querySelector('#infowindow').classList.remove('hidden');

					infoWindows.forEach((window) => {
						window.classList.remove('show');
						window.classList.add('hide');

						if (window.id === thisPolygon.owner) {
							window.classList.remove('hide');
							window.classList.add('show');
						}
					});

					// Set polygon click flag for use in map event listener below
					if (google.maps.geometry.poly.containsLocation(event.latLng, polygon)) {
						polygonClickFlag = true;
					}
				});

				// Set the polygon
				polygon.setMap(map);
			});
		});

		document.getElementById('contact-gmap-sales').addEventListener('click', () => {
			if (!polygonClickFlag) {
				document.querySelector('#infowindow').classList.remove('hidden');
				// Set all polygons to transparent
				for (let i = 0; i < allPolygons.length; i++) {
					allPolygons[i].setOptions({ strokeOpacity: 0, fillOpacity: 0 });
					allPolygons[i].selected = false;
				}
				// Show Coporate Sales Window
				infoWindows.forEach((window) => {
					window.classList.remove('show');
					window.classList.add('hide');
					if (window.id === 'corporate-sales') {
						window.classList.remove('hide');
						window.classList.add('show');
					}
				});
			}
			polygonClickFlag = false;
		});
	};

	$(window).load(function () {
		var mapEl = document.getElementById('contact-gmap-sales');
		if (!mapEl) return;

		var placeholderEl = document.getElementById('contact-gmap-sales-placeholder');

		mapConsent.whenMapsConsentGranted(function () {
			mapConsent.loadGoogleMapsScript(MSWObject.google_maps_script_url).then(function () {
				mapConsent.showMap(placeholderEl, mapEl);
				createContactSalesMap();
			});
		});
	});
})(jQuery);
